<template>
  <div class="foreground">    

    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
        <col width="30px">
        <col width="30px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Code"
        code="code"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Expiry"
        code="expiry"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Remaining"
        code="quantity"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
  
      </tr>

      <row
      v-for="item in items" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      @click.native="clickRow(item)"
      @editQuantity="editQuantity"
      ></row>

    </table>

    <!-- PAGINATION -->
    <c-pagination
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->

    <!-- DIALOGS -->
    <edit-quantity-dialog ref="editQuantityDialog" @onUpdate="loadAPI"></edit-quantity-dialog>
  </div>
</template>

<script>
import Row from './row'
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import EditQuantityDialog from '@/components/v/inventory/edit-inv-quantity-dialog'
import CTableHeader from '@/components/list-server/th'

export default {
  props: ['id'],
  components: {
    Row,
    EditQuantityDialog,
    CTableHeader
  },
  mixins: [ServerListController, ServerListBindings],
    data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: 'code',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0,
      currentIndex: 0
    }
  },
  watch: {
    id (nv) {
      this.loadAPI()
    }
  },
  methods: {
    editQuantity (id) {
      this.$refs.editQuantityDialog.open(id)
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/inventory/definition/${this.id}/history/?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            if (this.items.length > rows.length) {
              this.currentIndex = 0
            }
            console.log(response)
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>